<template>
  <div class="item form-group mb-0" :class="{ failed: error }">
    <label v-if="label" :for="id" class="block font-bold uppercase mb-1">
      {{ label }}
      <span v-if="required">*</span>
    </label>
    <select
      :id="id"
      v-bind="$attrs"
      class="form-control"
      @input="$emit('update:modelValue', $event.target.value)"
    >
      <template v-for="option in options" :key="`${option.value}`">
        <optgroup
          :label="option.label"
          :key="`pg${option.value}`"
          v-if="option.options"
        >
          <option
            v-for="childOption in option.options"
            :key="`${childOption.value}`"
            :value="childOption.value"
            :selected="childOption.value === modelValue"
          >
            {{ childOption.label }}
          </option>
        </optgroup>
        <option
          :value="option.value"
          :selected="option.value === modelValue"
          v-else
        >
          {{ option.label }}
        </option>
      </template>
    </select>
  </div>
</template>
<script>
import { onMounted } from 'vue'
export default {
  name: 'SelectField',
  props: {
    id: {
      type: String,
      default: Math.random().toString(36).substring(7),
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      default: null,
    },
    modelValue: String,
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    onMounted(() => {
      if (!props.modelValue && props.defaultValue) {
        emit('update:modelValue', props.defaultValue.toString())
      } else if (!props.modelValue && props.options.length) {
        let firstValue = [...props.options].shift().value
        if (props.options[0].options) {
          firstValue = [...props.options[0].options].shift().value
        }
        emit('update:modelValue', firstValue)
      }
    })
  },
}
</script>
